module.exports = __webpack_public_path__ + "img/kj_images_01.a18d2b59.png";